import React from "react";
import { Service } from "../service";
import styles from "./ServiceList.styles";

export const ServiceList: React.FC = () => {
	return (
		<>
			<h2 css={styles.heading}>Naše usluge</h2>
			<div css={styles.container}>
				<Service
					image="/images/terapija.jpg"
					title="Terapija pomoću konja"
					descriptionList={[
						"2 puta tjedno po 30 minuta.",
						"75€",
						"Jahanje i boravak na ranču su na vlastitu odgovornost",
					]}
				/>

				<Service
					image="/images/terensko-jahanje.jpg"
					title="Terensko jahanje"
					descriptionList={[
						"45 minuta",
						"40€",
						"Jahanje i boravak na ranču su na vlastitu odgovornost",
					]}
				/>

				<Service
					image="/images/turisticko-jahanje.jpg"
					title="Turističko jahanje"
					descriptionList={[
						"1 sat i 30 minuta",
						"100€ za jednu osobu + 40€ za svaku dodatnu osobu",
						"Jahanje i boravak na ranču su na vlastitu odgovornost",
					]}
				/>

				<Service
					image="/images/skola-jahanja.jpg"
					title="Škola jahanja"
					descriptionList={[
						"10 školskih sati / 20 školskih sati",
						"250€ / 450€",
						"Jahanje i boravak na ranču su na vlastitu odgovornost",
					]}
				/>
			</div>
		</>
	);
};
